module.exports = __webpack_public_path__ + "06_medium_black.7eb5827d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_medium_black.png
// module id = 0YKo
// module chunks = 0